import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Guarantee() {
  return <section className="py-16 px-6 bg-[#0a0a0a] relative" data-id="element-117">
      <div className="max-w-3xl mx-auto text-center" data-id="element-118">
        <FadeIn data-id="element-119">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-brand-rose/10 mb-6" data-id="element-120">
            <ShieldCheck className="w-10 h-10 text-brand-rose" data-id="element-121" />
          </div>
          <h2 className="font-serif text-3xl md:text-4xl font-bold mb-4 text-brand-cream" data-id="element-122">
            Garantía total
          </h2>
          <p className="text-lg text-brand-lightGray max-w-xl mx-auto" data-id="element-123">
            Si no notas más respuestas, te devolvemos el dinero. Sin preguntas.
          </p>
        </FadeIn>
      </div>
    </section>;
}